import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './ligas.css';
import { ligas_item } from '../../json/ligasitems';
const Ligas =  () => {
  useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
return (
<div className='container ligas-container container-mh'>
        <div className='row'>
            <div className='col-12'>
                <div className='ligas_title'>
                    <h1>Ligas de Interés</h1>
                    <br></br>
                    <hr class="hr-gob"></hr>
                </div>
            </div>
        </div>
        <div className="container-armon">
        <div className='row'>
            {
                ligas_item.map((item, index)=>(
                    <div key={ index } className='col-md-4 col-sm-6 col-12 ligas_item' >
                    <Link to={ item.ligas_item_url }>{ item.ligas_item_nombre }</Link>
                    </div>
                    
                ))
            }
        </div>
      </div>
    </div>
  )
}
export default Ligas






